import i18next from 'i18next';
import dayjs from 'dayjs';
import { Button } from 'react-bootstrap';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { formatCurrency } from 'src/utils';
import type { Quotation, QuotationSource } from 'src/quotations/types';
import { isQuickoSource } from 'src/quotations/config';
import { quickoNoleggiatoreLabel } from 'src/utils/quicko';

type Row = { row: { original: Quotation } };

export const sourceLabel = (source: QuotationSource): string =>
	({
		stock_offer: i18next.t('quotation_source_stock_offer', { defaultValue: 'Offerta stock' }),
		stock_quicko: i18next.t('quotation_source_stock_quicko', { defaultValue: 'Quicko stock' }),
		custom_offer: i18next.t('quotation_source_custom_offer', { defaultValue: 'Offerta libera' }),
		stellantis: i18next.t('quotation_source_stellantis', { defaultValue: 'Stellantis' }),
		configurator: i18next.t('quotation_source_configurator', { defaultValue: 'Configuratore' }),
	})[source] ?? source;

export const noleggiatoreLabel = ({ source, noleggiatore }: Quotation) =>
	isQuickoSource(source) && noleggiatore
		? quickoNoleggiatoreLabel(noleggiatore)
		: noleggiatore;

export const createColumnsData = (onOpen: (item: Quotation) => void) => [
	{
		width: 230,
		accessor: 'code',
		id: 'code',
		Header: i18next.t('quotation_code', { defaultValue: 'Codice' }),
		disableSortBy: true,
		Cell: ({ value }: { value: string | null }) => value || '—',
	},
	{
		width: 140,
		accessor: 'createdAt',
		id: 'createdAt',
		Header: i18next.t('creation_date', { defaultValue: 'Data' }),
		disableSortBy: true,
		Cell: ({ value }: { value: string }) =>
			value ? dayjs(value).format('DD/MM/YYYY HH:mm') : '—',
	},
	{
		width: 160,
		accessor: 'client',
		id: 'client',
		Header: i18next.t('quotation_recipient_short', { defaultValue: 'Intestatario' }),
		disableSortBy: true,
		Cell: ({ value }: { value: string }) => value || '—',
	},
	{
		width: 160,
		accessor: 'userAffiliation',
		id: 'userAffiliation',
		Header: i18next.t('dealer'),
		disableSortBy: true,
		Cell: ({ value }: { value: string }) => value || '—',
	},
	// {
	// 	width: 130,
	// 	accessor: 'source',
	// 	id: 'source',
	// 	Header: i18next.t('quotation_source', { defaultValue: 'Origine' }),
	// 	disableSortBy: true,
	// 	Cell: ({ value }: { value: QuotationSource }) => (
	// 		<span className="badge bg-light text-dark">{sourceLabel(value)}</span>
	// 	),
	// },
	{
		width: 130,
		accessor: 'makeLabel',
		id: 'makeLabel',
		Header: i18next.t('brand'),
		disableSortBy: true,
		Cell: ({ value }: { value: string }) => value || '—',
	},
	{
		width: 130,
		accessor: 'modelLabel',
		id: 'modelLabel',
		Header: i18next.t('model'),
		disableSortBy: true,
		Cell: ({ value }: { value: string }) => value || '—',
	},
	{
		width: 220,
		accessor: 'trimLabel',
		id: 'trimLabel',
		Header: i18next.t('car_setup'),
		disableSortBy: true,
		Cell: ({ value }: { value: string | null }) => value || '—',
	},
	// {
	// 	width: 120,
	// 	accessor: 'canone',
	// 	id: 'canone',
	// 	Header: i18next.t('rental_fee'),
	// 	disableSortBy: true,
	// 	Cell: ({ value }: { value: number | null }) =>
	// 		value != null ? formatCurrency(value) : '—',
	// },
	{
		width: 60,
		id: 'actions',
		Header: '',
		disableSortBy: true,
		Cell: ({ row }: Row) => {
			const openLabel = i18next.t('open', { defaultValue: 'Apri' });
			return (
				<Button
					variant="link"
					className="p-0"
					aria-label={openLabel}
					title={openLabel}
					onClick={() => onOpen(row.original)}
				>
					<FaExternalLinkAlt size={16} />
				</Button>
			);
		},
	},
];
